import { samplesSlice } from "store/slices/samplesSlice";
import { AppDispatch } from "@/store/store";

const {
  init,
  subjectsSettings,
  typesSettings,
  levelsSettings,
  formatsSettings,
  filter,
  search,
  modalOpen,
  clear,
} = samplesSlice.actions;

export const showSamples = () => (dispatch: AppDispatch) => dispatch(init());

export const filterSamples = () => (dispatch: AppDispatch) => {
  return dispatch(filter());
};

export const setSubjects = (ids: (number | string)[]) => (dispatch: AppDispatch) => {
  dispatch(subjectsSettings(ids));
  dispatch(filter());
};

export const setTypes = (ids: (number | string)[]) => (dispatch: AppDispatch) => {
  dispatch(typesSettings(ids));
  dispatch(filter());
};
export const setLevels = (ids: (number | string)[]) => (dispatch: AppDispatch) => {
  dispatch(levelsSettings(ids));
  dispatch(filter());
};
export const setFormats = (ids: (number | string)[]) => (dispatch: AppDispatch) => {
  dispatch(formatsSettings(ids));
  dispatch(filter());
};
export const setSearch = (value: string) => (dispatch: AppDispatch) => {
  dispatch(search(value));
  dispatch(filter());
};
export const setModalOpen = (bool: boolean) => (dispatch: AppDispatch) => dispatch(modalOpen(bool));

export const setClear = () => (dispatch: AppDispatch) => {
  dispatch(clear());
  dispatch(filter());
};
